import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { GoalId, GoalRelatedGoal } from '../../types';
import { GoalLabel } from './GoalLabel';
import { GoalHierarchyConnected } from '../../GoalSidebar/GoalHierarchy/GoalHierarchyConnected';

type Props = {
  goalId: GoalId;
  parent: GoalRelatedGoal | null;
  children: GoalRelatedGoal[];
};

const i18prefix = 'performanceReview.goals2.goalStatusCard.';

export const GoalRelatedLabel: React.FC<Props> = ({
  goalId,
  parent,
  children,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const hasRelationships = parent !== null || children.length > 0;

  if (!hasRelationships) {
    return null;
  }

  const getLabelText = () => {
    if (parent && children.length > 0) {
      const childText = t(i18prefix + 'child', { count: children.length });
      return t(i18prefix + 'hasParentAndChildren', {
        count: children.length,
        child: childText,
      });
    }
    if (parent) {
      return t(i18prefix + 'hasParent');
    }
    if (children.length > 0) {
      return t(i18prefix + 'children', { count: children.length });
    }
    return '';
  };

  const popoverContent = (
    <Popover style={{ minWidth: '30rem' }} id="goal-related-popover">
      <Popover.Body>
        <GoalHierarchyConnected
          goalId={goalId}
          onLinkClick={() => setShow(false)}
        />
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      overlay={popoverContent}
      placement="right"
      trigger="click"
      rootClose
      show={show}
      onToggle={(nextShow) => setShow(nextShow)}>
      <span className="cu-pointer">
        <GoalLabel
          icon="link-outline"
          label={getLabelText()}
          className="me-3"
          noWrap={true}
        />
      </span>
    </OverlayTrigger>
  );
};
